import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, Injectable, NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpEventsInterceptor } from 'core/api';
import { ConfigService } from 'core/config';
import { CustomIconsLoaderService, SSErrorHandler, SSLocalStorageService } from 'core/services';
import { SharedComponentsModule } from 'core/shared-components';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { Observable } from 'rxjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './modules/auth/auth.module';
import { ProcessOverviewModule } from './modules/process-overview/process-overview.module';
import { SignProcessWizardModule } from './modules/sign-process-wizard/sign-process-wizard.module';
import { UserManagementModule } from './modules/user-management/user-management.module';
import { AuthInterceptor } from './root/http-interceptors/auth.interceptor';
import { CacheBusterInterceptor } from './root/http-interceptors/cache-buster.interceptor';
import { LanguageInterceptor } from './root/http-interceptors/language.interceptor';
import { LogHttpEventsInterceptor } from './root/http-interceptors/log.http-events.interceptor';
import { SidenavModule } from './root/sidenav/sidenav.module';

@Injectable()
class TranslateHttpLoader extends TranslateLoader {

  constructor(
    private readonly http: HttpClient
  ) {

    super()
  }

  getTranslation(lang: string): Observable<any> {

    return this.http.get(`assets/i18n/${lang}.json`)
  }
}


const TranslateModuleRoot = TranslateModule.forRoot({
  defaultLanguage: 'hr',
  loader: {
    provide: TranslateLoader,
    useClass: TranslateHttpLoader,
    deps: [HttpClient],
  }
})

const LOG_URL = '/secure-sign-api/log';
const loggerModuleRoot = LoggerModule.forRoot({
  serverLoggingUrl: window.location.origin + LOG_URL,
  level: NgxLoggerLevel.DEBUG,
  serverLogLevel: NgxLoggerLevel.ERROR,
})


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    AuthModule,
    SignProcessWizardModule,
    TranslateModuleRoot,
    MatNativeDateModule,
    BrowserAnimationsModule,
    SidenavModule,
    SharedComponentsModule,
    ProcessOverviewModule,
    UserManagementModule,
    MatDialogModule,
    MatSnackBarModule,
    loggerModuleRoot
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService, customIconsLoaderService: CustomIconsLoaderService) => async () => {
        await configService.load()
        customIconsLoaderService.loadIcons();
      },
      multi: true,
      deps: [ConfigService, CustomIconsLoaderService, SSLocalStorageService]
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheBusterInterceptor, multi: true },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        closeOnNavigation: false,
        role: 'dialog',
        disableClose: true,
        maxHeight: '100dvh'
      } as MatDialogConfig
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill', floatLabel: 'auto' } as MatFormFieldDefaultOptions
    },
    {
      provide: ErrorHandler,
      useClass: SSErrorHandler
    },
    {
      provide: HttpEventsInterceptor,
      useClass: LogHttpEventsInterceptor
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


